<template>
  <page-news-layout>
    <div>
      <h2>{{ $t("about_us_news_right_flex_three") }}</h2>
    </div>
    <div v-for="(c, index) in content" :key="c">
      <div v-if="index == 4">
        <p>
          {{ $t(c.p) }}
        </p>
      </div>
      <div v-else>
        <p>
          {{ $t(c.p) }}
        </p>
        <h3>{{ $t(c.h) }}</h3>
      </div>
    </div>
    <div class="mt-5 mb-5">
      <base-link-button link="/about"></base-link-button>
    </div>
  </page-news-layout>
</template>
<script>
import BaseLinkButton from "@/components/BaseLinkButton.vue"
import PageNewsLayout from "@/components/PageNewsLayout.vue"
export default {
  components: { BaseLinkButton, PageNewsLayout },
  name: "HowErp",
  data() {
    return {
      chips: [{ chip: "#erp" }],

      content: [
        { p: "HowErp_p1", h: "HowErp_h1" },
        { p: "HowErp_p2", h: "HowErp_h2" },
        { p: "HowErp_p3", h: "HowErp_h3" },
        { p: "HowErp_p4", h: "HowErp_h4" },
        { p: "HowErp_p5" }
      ]
    }
  }
}
</script>
